module.exports = __webpack_public_path__ + "cb436ee6.jpg";